"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
const clsx = require("../../../chunks/clsx-CBkIpawf.js");
const foundations_typography_Text_Text = require("../../../foundations/typography/Text/Text.js");
const components_utility_spacing_spacing = require("../../utility/spacing/spacing.js");
const components_feedback_helpers_getFeedbackIcon = require("../helpers/getFeedbackIcon.js");
const components_feedback_Alert_AlertContent = require("../../../chunks/AlertContent-DVIommV8.js");
const Alert = ({
  children,
  notifyScreenReader,
  titleHeadingLevel = "h3",
  variant = "info",
  title,
  spacings,
  className,
  ...props
}) => {
  if (!title && !children) {
    console.error("You need to pass either a title or children prop for the Alert to render");
  }
  const icon = components_feedback_helpers_getFeedbackIcon.getFeedbackIcon(variant);
  const shouldNotifySR = notifyScreenReader !== void 0 ? notifyScreenReader : variant === "error";
  return /* @__PURE__ */ jsxRuntime.jsxs(
    "div",
    {
      className: clsx.clsx(components_feedback_Alert_AlertContent.styles.alert, components_feedback_Alert_AlertContent.styles["alert-" + variant], components_utility_spacing_spacing.spacingHelper(spacings), className),
      role: shouldNotifySR ? "alert" : "status",
      ...props,
      children: [
        icon,
        /* @__PURE__ */ jsxRuntime.jsxs("div", { className: components_feedback_Alert_AlertContent.styles.alertMain, children: [
          title && typeof title === "string" && /* @__PURE__ */ jsxRuntime.jsx(
            foundations_typography_Text_Text.Text,
            {
              variant: "text-body-head",
              component: titleHeadingLevel || "h3",
              className: components_feedback_Alert_AlertContent.styles.alertTitle,
              children: title
            }
          ),
          /* @__PURE__ */ jsxRuntime.jsx(components_feedback_Alert_AlertContent.AlertContent, { children })
        ] })
      ]
    }
  );
};
exports.Alert = Alert;
